import { render } from "./savedCartsOverview.vue?vue&type=template&id=1ca83942&scoped=true&ts=true"
import script from "./savedCartsOverview.vue?vue&type=script&lang=ts"
export * from "./savedCartsOverview.vue?vue&type=script&lang=ts"

import "./savedCartsOverview.vue?vue&type=style&index=0&id=1ca83942&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca83942"]])

export default __exports__